import { Yup } from '../../services/common/validation';

export const AccessoriesCostPopupModalSchema = () => {
  return Yup.object().shape({
    priceBeforeTax5: Yup.number(),
    priceWithTax5: Yup.number(),
    priceBeforeTax20: Yup.number(),
    priceWithTax20: Yup.number(),
  });
};
